import Alert from "@mui/material/Alert";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { Link as RouterLink } from "react-router-dom";

interface SecretaryAgentEndpointNoticeProps {
  isEndpointLoading: boolean;
  hasActiveMetaEndpoint: boolean;
}

/**
 * Aviso de pré-condição da Secretária IA: exige WhatsApp Business (Meta).
 * Exibido no card enquanto a extensão ainda não está ativa.
 */
export function SecretaryAgentEndpointNotice({
  isEndpointLoading,
  hasActiveMetaEndpoint,
}: SecretaryAgentEndpointNoticeProps) {
  if (isEndpointLoading) {
    return (
      <Typography variant="body2" color="text.secondary">
        Verificando o canal WhatsApp Business (Meta)...
      </Typography>
    );
  }

  if (hasActiveMetaEndpoint) {
    return (
      <Alert severity="info" sx={{ textAlign: "left" }}>
        <Typography variant="body2">
          A Secretária IA funciona com o WhatsApp Business (Meta).
        </Typography>
      </Alert>
    );
  }

  return (
    <Alert severity="info" sx={{ textAlign: "left" }}>
      <Typography variant="body2" sx={{ mb: 0.75 }}>
        Para ativar a Secretária IA, sua clínica precisa ter o WhatsApp Business
        (Meta) conectado. O plano com número padrão Fluxmed não permite esta
        extensão.
      </Typography>
      <Typography variant="body2">
        Ao alterar para o plano com número padrão Fluxmed, a Secretária IA também
        será desligada se estiver ativa.{" "}
        <Link component={RouterLink} to="/fluxzap" fontWeight={600}>
          Configurar canal no FluxZap
        </Link>
      </Typography>
    </Alert>
  );
}
